import { useCallback, type ReactNode } from 'react';
import { atom, useRecoilValue, useSetRecoilState } from 'recoil';
import { useInterval } from '../utils';

const nowAtom = atom({
  key: 'now',
  default: new Date(),
});

export function NowContext({ children }: { children: ReactNode }) {
  const setNow = useSetRecoilState(nowAtom);
  const updateNow = useCallback(() => setNow(new Date()), [setNow]);
  useInterval(updateNow, 1000);

  return <>{children}</>;
}

export function useNow() {
  return useRecoilValue(nowAtom);
}
